import { useAtom } from "jotai";
import { useEffect, useRef, useState } from "react";

import { getDemandeByPatientPaginated } from "../../api/medecin";
import { userAtom } from "../../state/auth";
import TasksContainer from "../../components/MyRequests/TasksContainer";
import Input from "../../components/Input";

import { ReactComponent as IconSearch } from "../../assets/icons/icon-search.svg";
import "./styles/main.css";
import "./styles.scss";
import { refreshAtomRequest } from "../../state/refreshRequestList";

const SinglePatientRequests = () => {
  const [refresh] = useAtom(refreshAtomRequest);

  const typingTimeoutRef = useRef(null) as any;
  const [user] = useAtom(userAtom);
  const [demandesEncours, setDemandesEncours] = useState([]) as any;
  const [demandesWaiting, setDemandesWaiting] = useState([]) as any;
  const [demandesDone, setDemandesDone] = useState([]) as any;
  const [demandesDraft, setDemandesDraft] = useState([]) as any;
  const [demandesDoneChirugien, setDemandesDoneChirugien] = useState([]) as any;
  const [demandesEncoursChirugien, setDemandesEncoursChirugien] = useState(
    []
  ) as any;
  const [update, setUpdate] = useState(false);
  const [indexDone, setIndexDone] = useState(2);
  const [indexWaiting, setIndexWaiting] = useState(2);
  const [indexEncours, setIndexEncours] = useState(2);
  const [totalCountsEnCours, setTotalCountsEnCours] = useState(0) as any;
  const [totalCountsWaiting, setTotalCountsWaiting] = useState(0) as any;
  const [currentPageDone, setCurrentPageDone] = useState(1);
  const [currentPageNotYet, setCurrentPageNotYet] = useState(1);
  const [currentPageDraft, setCurrentPageDraft] = useState(1);
  const [currentPageInProgress, setCurrentPageInProgress] = useState(1);
  const [totalCountsDone, setTotalCountsDone] = useState(0) as any;
  const [hasMoreEncours, setHasMoreEncours] = useState(true);
  const [hasMoreWaiting, setHasMoreWaiting] = useState(true);
  const [hasMoreDone, setHasMoreDone] = useState(true);
  const [limit] = useState(10);
  const done = ["RESPONSE", "SEEN_BY_REQ"];
  const [title] = useState("En Cours");
  const [textSearch, setTextSearch] = useState("");
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    typingTimeoutRef.current = setTimeout(() => {
      if (searchValue.length >= 1) {
        setDemandesEncours([]);
        setDemandesWaiting([]);
        setDemandesDone([]);
        setDemandesDraft([]);
        setDemandesDoneChirugien([]);
        setDemandesEncoursChirugien([]);
        setTextSearch(searchValue);
      } else {
        clearSearch();
      }
    }, 1000);

    return () => clearTimeout(typingTimeoutRef.current);
  }, [searchValue]);

  const clearSearch = () => {
    setSearchValue("");
    setTextSearch("");
  };

  const onSearch = (e) => {
    const value = e.target.value.toLowerCase().trim();
    setSearchValue(value);
    if (value === "") {
      window.location.reload();
    }
  };

  const fetchMoreDataDone = async () => {
    console.log("hello 1");

    try {
      const res = await getDemandeByPatientPaginated(
        indexDone,
        limit,
        done,
        textSearch
      );

      if (res) {
        setDemandesDone((prevItems) => {
          return [...prevItems, ...res.dones];
        });

        res.dones.length > 0 ? setHasMoreDone(true) : setHasMoreDone(false);
      }
      setIndexDone((prevIndex) => prevIndex + 1);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchMoreDataNotYet = async () => {
    console.log("hello 2");

    try {
      const res = await getDemandeByPatientPaginated(
        indexWaiting,
        limit,
        "NOTYET",
        textSearch
      );

      if (res) {
        setDemandesWaiting((prevItems) => {
          return [...prevItems, ...res.notYet];
        });
        console.log("demandes", res.notYet);
        res.notYet.length > 0
          ? setHasMoreWaiting(true)
          : setHasMoreWaiting(false);
      }
      setIndexWaiting((prevIndex) => prevIndex + 1);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchMoreDataInProgress = async () => {
    console.log("hello 3");
    try {
      const res = await getDemandeByPatientPaginated(
        indexEncours,
        limit,
        "INPROGRESS",
        textSearch
      );

      if (res) {
        setDemandesEncours((prevItems) => [...prevItems, ...res.InProgress]);
        res.InProgress.length > 0
          ? setHasMoreEncours(true)
          : setHasMoreEncours(false);
      }
      setIndexEncours((prevIndex) => prevIndex + 1);
    } catch (error) {
      console.log(error);
    }
  };

  const handleKeyDown = (event) => {
    const value: string = event.target.value.toLowerCase().trim();
    if (event.key === "Enter" || event.key === "Tab" || event.key === " ") {
      if (value.length >= 1) {
        setDemandesEncours([]);
        setDemandesWaiting([]);
        setDemandesDone([]);
        setDemandesDraft([]);
        setDemandesDoneChirugien([]);
        setDemandesEncoursChirugien([]);
        setTextSearch(value);
        setSearchValue(value);
      } else {
        setSearchValue("");
        setTextSearch("");
      }
    }
  };

  const demandesData = async () => {
    try {
      let doneResponse, notYetResponse, inProgressResponse;

      doneResponse = await getDemandeByPatientPaginated(
        currentPageDone,
        limit,
        done,
        textSearch
      );
      inProgressResponse = await getDemandeByPatientPaginated(
        currentPageInProgress,
        limit,
        "INPROGRESS",
        textSearch
      );
      notYetResponse = await getDemandeByPatientPaginated(
        currentPageNotYet,
        limit,
        "NOTYET",
        textSearch
      );

      // Handle "Done" requests
      if (doneResponse && doneResponse.dones.length > 0) {
        if (doneResponse.dones.length < limit) {
          setHasMoreDone(false);
        }
        setDemandesDone(doneResponse.dones);
        setTotalCountsDone(doneResponse?.counts?.dones);
      } else {
        setHasMoreDone(false);
      }

      // Handle "Not Yet" requests
      if (notYetResponse && notYetResponse.notYet.length > 0) {
        if (notYetResponse.notYet.length < limit) {
          setHasMoreWaiting(false);
        }
        setDemandesWaiting(notYetResponse.notYet);
        setTotalCountsWaiting(notYetResponse?.counts?.notYet);
      } else {
        setHasMoreWaiting(false);
      }

      // Handle "In Progress" requests
      if (inProgressResponse && inProgressResponse.InProgress.length > 0) {
        if (inProgressResponse.InProgress.length < limit) {
          setHasMoreEncours(false);
        }
        setDemandesEncours(inProgressResponse.InProgress);

        setTotalCountsEnCours(inProgressResponse?.counts?.InProgress);
      } else {
        setHasMoreEncours(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    demandesData();
  }, [
    textSearch,
    refresh?.state,
    currentPageDone,
    currentPageNotYet,
    currentPageInProgress,
    currentPageDraft,
  ]);

  return (
    <>
      {/* <div className="relative flex w-full flex-wrap mx-4 ">
        <span className="z-10 h-full leading-snug font-normal  text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-1 py-1">
          <IconSearch />
        </span>
        <Input
          value={searchValue}
          type="text"
          placeholder="Recherche par médecin"
          width="w-full"
          onKeyDown={handleKeyDown}
          onChange={onSearch}
          className="rounded-xl px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white  text-sm outline-none focus:border-blue-500  border-blue-100 w-full pl-10"
        />
      </div> */}
      <div className="relative flex w-full flex-wrap mx-4 ">
        <h2>Status de votre téléexpertise</h2>
      </div>
      <div className="block">
        <div className=" h-screen mx-3 h-min-screen flex flex-col-reverse sm:flex-row">
          <TasksContainer
            setUpdate={setUpdate}
            title={title}
            titleBorder
            tasks={demandesEncours}
            userType={user?.type}
            fetchMoreData={fetchMoreDataInProgress}
            hasMore={hasMoreEncours}
            id="scrollableEncoursDiv"
            totalCounts={totalCountsEnCours}
          />
          <TasksContainer
            setUpdate={() => setUpdate}
            title="En Attente de validation"
            tasks={demandesWaiting}
            userType={user?.type}
            fetchMoreData={fetchMoreDataNotYet}
            hasMore={hasMoreWaiting}
            id="scrollableWaitingDiv"
            totalCounts={totalCountsWaiting}
          />
          <TasksContainer
            setUpdate={() => setUpdate}
            title="Reçues"
            tasks={demandesDone}
            userType={user?.type}
            fetchMoreData={fetchMoreDataDone}
            hasMore={hasMoreDone}
            id="scrollableDoneDiv"
            totalCounts={totalCountsDone}
          />
        </div>
      </div>
    </>
  );
};

export default SinglePatientRequests;
